import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import classnames from 'classnames';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';

import CustomButton from '../../CustomButton';
import { createCompanyCustomer } from '../../../action/CompaniesActions'

import '../../dump/menuComponents/menuComponents.sass';

const CompanyAddContainer = (props) => {
	const navigate = useNavigate();
	const { user, company, toggleLoader } = props;
	const userRole = user.roles[0];

	const [data, setData] = useState({
		company_name: '',
		company_city: '',
		company_state: '',
		company_zipcode: '',
		company_address: '',
		company_country: '',
		industry_type: ''
	})
	const [errMessage, setErrMessage] = useState({
		company_name: '',
		company_city: '',
		company_state: '',
		company_zipcode: '',
		company_address: '',
		company_country: '',
		industry_type: ''
	})
	const [companySaved, setCompanySaved] = useState(false)
	const [openNewCompany, setOpenNewCompany] = useState(false)
	const [created_company, setCreated_company] = useState(false)

	useEffect(() => {
		setData({ ...data, partner_company: user.company_name });
	}, [])

	const onCancel = (e) => {
		e.preventDefault();
		const data = {
			company_name: '',
			company_city: '',
			company_state: '',
			company_zipcode: '',
			company_address: '',
			company_country: '',
			industry_type: '',
		};

		setCompanySaved(false);
		setData(data);
		setOpenNewCompany(true);
	}

	const saveCompany = (e) => {
		const error = checkForm(data);
		const partner_name = data.partner_company || '';
		const initData = {
			live_active: false,
			cutoff_when_overage: true,
			storage_active: true,
			trace_active: true,
			data_limit: '0',
			billing_date: '1',
			trial_status: false,
			company_type: 'CUSTOMER',
		};

		if (!error) {
			toggleLoader(true);
			const state = { data: { ...data, ...initData } };
			createCompanyCustomer(state, userRole, partner_name)
				.then((res, err) => {
					const created_company = res.data.response.company;

					toggleLoader(false);
					setCompanySaved(true);
					setCreated_company(created_company);
					props.getCompanies();

					toastr.success('Success', 'Company was added');
					props.addCompany({ company: data.company_name });
				})
				.catch((error) => {
					toggleLoader(false);
					console.log('!createCompanyCustomer error: ', error);
					toastr.error(`Unable to create company. Please try again later`);
				})
		}
	}

	const checkForm = (data) => {
		let error = false;
		const updatedErrMessage = { ...errMessage };
		if (data.company_name.includes('/')) {
			error = true;
			updatedErrMessage['company_name'] = 'Company name cannot contain "/"'
		}
		else {
			for (let i in data) {
				if (data[i] === '' && i !== "company_address2" && i !== "company_phone_number") {
					error = true;
					updatedErrMessage[i] = 'Enter a ' + i.replaceAll('_', ' ');
				} else if (updatedErrMessage[i]) {
					updatedErrMessage[i] = null;
				}
			}
		}
		setErrMessage(updatedErrMessage)
		return error;
	}

	const handleInputChange = (event, optional = null) => {
		const { target } = event;
		const { name } = target
		let value = target.type === 'checkbox' ? target.checked : target.value

		if (name === 'download_files') {
			if (value) {
				value = 2; // all files
			} else {
				value = 1; // event files
			}
		}

		const updatedData = { ...data, [name]: value }

		if (name === 'company_type' && value === 'WCS') {
			setData({ ...updatedData, download_files: 1, file_retention_time: 12 });
		} else {
			if (updatedData.partner_company !== 'Rosco Vision WCS' && updatedData.company_type !== 'WCS') {
				delete updatedData.download_files;
				delete updatedData.file_retention_time;
			}

			if (optional && value === '') {
				delete updatedData[name]
			}

			setData(updatedData)
		}
	}

	const editCompany = () => {
		navigate('/company/edit', {
			state: { company: created_company },
		})
	}

	const toggleAddBlock = () => {
		setOpenNewCompany(!openNewCompany);
	}

	if (companySaved) {
		return (
			<div className="add-asset-block">
				<CustomButton
					variant="secondary-outline"
					onClick={onCancel}
				>
					Add Another Company
				</CustomButton>
				<div className="label-wrapper">
					<label>
						The new company, <b>{data.company_name}</b>, has been created.
					</label>
				</div>
				<div>
					<CustomButton
						variant="primary"
						onClick={editCompany}
					>
						Edit Company
					</CustomButton>
				</div>
			</div>
		)
	}

	const {
		company_name,
		company_city,
		company_state,
		company_zipcode,
		company_address,
		company_country,
		industry_type,
	} = errMessage;

	const industryTypeDisplayOptions = [
		'FTL/LTL/Courier',
		'Medical/Health',
		'School/Education',
		'Construction',
		'Waste Management',
		'Mass Transit',
		'Agricultural',
		'Government',
		'Industrial',
		'Other'
	]
	const industryTypeValueOptions = [
		'ftl_ltl_courier',
		'medical_health',
		'school_education',
		'construction',
		'waste_management',
		'mass_transit',
		'agricultural',
		'government',
		'industrial',
		'other'
	]

	return (
		<div className="add-asset-block">
			<CustomButton
				variant="secondary-outline"
				onClick={toggleAddBlock}
				// disabled={userRole !== 'partner'}
			>
				{openNewCompany ? 'Cancel' : 'Add a New Company'}
			</CustomButton>
			{openNewCompany
				&& (
					<div className="edit-content-block">
						<div className='two-column-grid'>
							<div className={classnames({ 'has-error': company_name })}>
								<label className="control-label">Name:</label>
								<input type="text" name="company_name" className="vehicle-search" onChange={handleInputChange} maxLength={50} />
								{company_name && <span className="help-block">{company_name}</span>}
							</div>

							<div className={classnames({ 'has-error': company_city })}>
								<label className="control-label">City:</label>
								<input type="text" name="company_city" className="vehicle-search" onChange={handleInputChange} />
								{company_city && <span className="help-block">{company_city}</span>}
							</div>

							<div className={classnames({ 'has-error': company_state })}>
								<label className="control-label">State:</label>
								<input type="text" name="company_state" className="vehicle-search" onChange={handleInputChange} />
								{company_state && <span className="help-block">{company_state}</span>}
							</div>

							<div className={classnames({ 'has-error': company_zipcode })}>
								<label className="control-label">Zip Code:</label>
								<input type="text" name="company_zipcode" className="vehicle-search" onChange={handleInputChange} />
								{company_zipcode && <span className="help-block">{company_zipcode}</span>}
							</div>

							<div className={classnames({ 'has-error': company_address })}>
								<label className="control-label">Address:</label>
								<input type="text" name="company_address" className="vehicle-search" onChange={handleInputChange} />
								{company_address && <span className="help-block">{company_address}</span>}
							</div>

							<div className={'optional'}>
								<label className="control-label">Address 2: <span>(optional)</span></label>
								<input type="text" name="company_address2" className="vehicle-search" onChange={(e) => handleInputChange(e, true)} />
							</div>

							<div className={classnames({ 'has-error': company_country })}>
								<label className="control-label">Country:</label>
								<input type="text" name="company_country" className="vehicle-search" onChange={handleInputChange} />
								{company_country && <span className="help-block">{company_country}</span>}
							</div>

							<div className="optional">
								<label className="control-label">Phone Number: <span>(optional)</span></label>
								<input type="text" name="company_phone_number" className="vehicle-search" onChange={(e) => handleInputChange(e, true)} />
							</div>

							<div className={classnames({ 'has-error': industry_type })}>
								<label className="control-label">Industry Type:</label>
								<select
									placeholder="select"
									className="rosco-select block"
									name="industry_type"
									id="industry_type"
									onChange={handleInputChange}>
									<option value="" />
									{industryTypeDisplayOptions.map((item, i) => (
										<option key={i} value={industryTypeValueOptions[i]}>{item}</option>
									))}
								</select>
								{industry_type && <span className="help-block">{industry_type}</span>}
							</div>
						</div>

						<CustomButton
							variant='primary'
							onClick={saveCompany}
						>
							Add Company
						</CustomButton>
					</div>
				)}
		</div>
	)
}

export default connect(
	state => ({
		user: state.user.user,
		company: state.company.company,
	}),
	dispatch => ({
		addCompany: (company) => {
			dispatch({ type: 'ADD_COMPANY_SUCCESS', payload: company });
		},
		toggleLoader: (show) => {
			dispatch({ type: 'TOGGLE_LOADER', payload: show });
		}
	})
)(CompanyAddContainer);
